import { createFileRoute } from '@tanstack/react-router';
import { MerchantManagementPage } from './MerchantManagementPage';
import { z } from 'zod';

const searchSchema = z.object({
  nameFilter: z.string().optional(),
  createdAfter: z.coerce.date().optional(),
  createdBefore: z.coerce.date().optional(),
  updatedAfter: z.coerce.date().optional(),
  updatedBefore: z.coerce.date().optional(),
  sortBy: z
    .enum(['name', 'created_at', 'updated_at', 'receipt_count', 'plaid_transaction_count'])
    .optional()
    .default('updated_at'),
  sortOrder: z.enum(['asc', 'desc']).optional().default('desc'),
  page: z.coerce.number().positive().int().optional().default(1),
  pageSize: z.coerce.number().positive().int().optional().default(25),
});

export const Route = createFileRoute('/_protected/admin/internal-tools/merchant-management/')({
  component: MerchantManagementPage,
  validateSearch: searchSchema,
});
